import { generator } from '@cms-max/cms-browser-api-client'
import { GeneratorArgs } from './generateEventMap'
import { Activity, Component } from '@cms-max/medicare-api-sdk'

export const premiumMonthlyGenerator = generator(({ i18n }: GeneratorArgs) => {
  const ns = 'premiumsMonthly'

  return {
    premiums_monthlypremiums_openalldetails_click: {
      core: {
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        property: 'MAX',
        elementId: 'premiums_monthlypremiums_openalldetails_click',
        coreClickData: {
          linkText: i18n.t('toggleCollapsibleCards.open', { ns })
        }
      }
    },
    premiums_monthlypremiums_closealldetails_click: {
      core: {
        activity: Activity.ButtonClick,
        component: Component.Premiums,
        property: 'MAX',
        elementId: 'premiums_monthlypremiums_closealldetails_click',
        coreClickData: {
          linkText: i18n.t('toggleCollapsibleCards.close', { ns })
        }
      }
    },
    premiums_monthlypremiums_opendetails_accordionopen: ({ date }: { date: string }) => {
      return {
        core: {
          activity: Activity.OpenAccordion,
          component: Component.Premiums,
          property: 'MAX',
          elementId: `premiums_monthlypremiums_opendetails${date}_accordionopen`
        }
      }
    },
    premiums_monthlypremiums_opendetails_accordionclose: ({ date }: { date: string }) => {
      return {
        core: {
          activity: Activity.CloseAccordion,
          component: Component.Premiums,
          property: 'MAX',
          elementId: `premiums_monthlypremiums_closedetails${date}_accordionclose`
        }
      }
    }
  }
})

export type PremiumMonthlyKeys = keyof ReturnType<
  typeof premiumMonthlyGenerator
>

export default premiumMonthlyGenerator
